import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IAdminsItem } from 'store/slices/admin/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import { saveAdminsItem, loadAdminsItem } from 'store/slices/admin/actions';

import { AdminForm } from './components/AdminForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit: React.FC = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.admins);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadAdminsItem(id));
  }, []);

  const onFinish = (values: IAdminsItem) => {
    setIsLoading(true);
    dispatch(saveAdminsItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/admin');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/admin');
  };

  return (
    <MainLayout pageTitle='Редактирование пользователя администратора'>
      {item.id && item.id === Number(id) ? (
        <AdminForm
          onFinish={onFinish}
          cancelButtonHandler={cancelButtonHandler}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
